import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

interface Props {
  label: string;
}

export const Stat: React.FC<Props> = ({ label, children }) => {
  return (
    <Box as="dl">
      <Text as="dt" variant="smallCaps" mb="4">
        {label}
      </Text>

      <Text as="dd" fontWeight={500}>
        {children}
      </Text>
    </Box>
  );
};
